export default "__VITE_ASSET__KNe2L0u3__"